module.exports = __webpack_public_path__ + "static/media/ajax-loader.bfbba4e1.svg";